import { ROUTE_PATH } from "common/constants/sm-constants";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class KtLogsGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'KT Logs',
            ROUTE_PATH.branchGrid,
            ROUTE_PATH.addBranches,           
            false,
            false,
            8,
            false,
            false,
            ['student_name'],
            true,
            [],
            { isDownloadExcel: true, excelFileName: 'kt-logs.xlsx', btnLabel: 'Download Logs', headers: [{ key: 'StudentName', value: 'student_name' }, { key: 'Semester', value: 'semester' }, { key: 'KT', value: 'ktstatusflag' }, { key: 'Date', value: 'created' }] },
            false,
            null,
            false,
            false,
            false,
            null,
            { evalKey: 'wantToDelete', evalParam: [1], decisiveParam: true }
           
            
        );
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const StudentName = new Headers('Student Name', 'student_name', false, true, 'text');
        const Semester = new Headers('Semester', 'semester', false, true, 'text');
        const ktStatus = new Headers('KT', 'ktstatusflag', false, true, 'text');
        const createdAt = new Headers('Updated Date', 'created', false, true, 'text');
        headers.push(StudentName);
        headers.push(Semester);
        headers.push(ktStatus);
        headers.push(createdAt);
        return headers;
    }
}
